import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/reset.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./redux";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
